<template>
  <div class="el-section">
    <anticipation-request></anticipation-request>
  </div>
</template>

<script>
import '@pagarme/anticipation-request/web-comp'

export default {
  name: 'anticipations'
}
</script>
